import { useEffect, useRef, useState } from "react";
import moment from "moment";
import { TournamentInfoInterface } from "../../../../api/game";
import { DashboardDailyTournament } from "../../../../api/dashboard";

export function TournamentTimer(start: string, end: number) {
  const timerRef = useRef<NodeJS.Timer>();
  const [timerText, setTimerText] = useState("--:--:--");

  useEffect(() => {
    const update = () => {
      if (end === 1 && timerRef.current) {
        clearInterval(timerRef.current);
      }

      const diff = Math.max(0, moment(start).diff(moment()));
      setTimerText(moment.utc(diff).format("HH:mm:ss"));
    };

    timerRef.current = setInterval(() => {
      update();
    }, 1000);

    update();

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [start, end]);

  return timerText;
}

function getCurrentLevelTime(data: DashboardDailyTournament): string {
  if (!data) return "";
  const { blindStructure } = data.tournamentInfo.info.data;
  const playStart = new Date(data.startAt).getTime();
  const now = new Date().getTime();

  const elapsedMs = now - playStart;
  if (elapsedMs < 0) return "";

  let accumulatedMs = 0;
  let currentLevel = 0;
  let currentBreak = false;
  let elapsedTimeInCurrentLevelMs = 0;

  for (let i = 0; i < blindStructure.length; i++) {
    const [isBreak, , , , durationSeconds, , level] = blindStructure[i];
    const durationMs = durationSeconds * 1000;

    const levelStart = accumulatedMs;
    const levelEnd = accumulatedMs + durationMs;

    if (elapsedMs < levelEnd) {
      currentLevel = level;
      currentBreak = isBreak === 1;
      elapsedTimeInCurrentLevelMs = elapsedMs - levelStart;
      break;
    }

    accumulatedMs += durationMs;
  }

  const minutes = Math.floor(elapsedTimeInCurrentLevelMs / 60000);
  const seconds = Math.floor((elapsedTimeInCurrentLevelMs % 60000) / 1000);
  const formattedMinutes = String(minutes).padStart(2, "0");
  const formattedSeconds = String(seconds).padStart(2, "0");

  return currentBreak
    ? `BREAK ${formattedMinutes}:${formattedSeconds}`
    : `LV${currentLevel} ${formattedMinutes}:${formattedSeconds}`;
}

export function CurrentLevelTime(data: DashboardDailyTournament) {
  const [timeString, setTimeString] = useState(() => getCurrentLevelTime(data));

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeString(getCurrentLevelTime(data));
    }, 1000);
    return () => clearInterval(interval);
  }, [data]);

  return timeString;
}
